// constants/projectsData.ts
import { Project } from "../types/project";
  
export const PROJECTS_DATA: Project[] = [
  {
    id: "project-1",
    title: "Personal Fitness Platform",
    description: "A full-stack fitness web app featuring meal tracking, exercise logging, and progress analytics.",
    longDescription:
      "Built with React and Express, this platform lets users track daily nutrition and workouts, view progress charts over time, and manage personal goals. I designed the JWT-authenticated REST API, SQL database schema, and a responsive React dashboard with data-visualisation components.",
    link: "https://personal-fitness-assistant.netlify.app/",
    repositoryUrl: "https://github.com/Shah-K02/Fitness-Tool-Project",
    githubUrl: "https://github.com/Shah-K02/Fitness-Tool-Project",
    liveUrl: "https://personal-fitness-assistant.netlify.app/",
    demoUrl: "https://personal-fitness-assistant.netlify.app/",
    image: "https://images.unsplash.com/photo-1544367567-0f2fcb009e0b?w=800&h=500&fit=crop",
    technologies: ["React", "Express", "Node.js", "SQL", "CSS", "RESTful API", "JWT", "Axios"],
    screenshots: [
      "https://images.unsplash.com/photo-1571019613454-1cb2f99b2d8b?w=800&h=500&fit=crop",
      "https://images.unsplash.com/photo-1526506118085-60ce8714f8c5?w=800&h=500&fit=crop",
    ],
    status: "completed",
    category: "Web Development",
    year: 2024,
  },
  {
    id: "project-2",
    title: "AutoMods",
    description: "A full-stack marketplace for sourcing and listing car parts and modifications.",
    longDescription:
      "AutoMods connects car enthusiasts with parts suppliers through a real-time inventory system built with React, TypeScript, and Socket.io. I architected the PostgreSQL database, implemented live search and filtering, and designed the responsive Tailwind CSS UI across categories of OEM and aftermarket parts.",
    link: "https://github.com/Shah-K02/AutoMods",
    repositoryUrl: "https://github.com/Shah-K02/AutoMods",
    githubUrl: "https://github.com/Shah-K02/AutoMods",
    liveUrl: "https://github.com/Shah-K02/AutoMods",
    demoUrl: "https://github.com/Shah-K02/AutoMods",
    image: "https://images.unsplash.com/photo-1492144534655-ae79c964c9d7?w=800&h=500&fit=crop",
    technologies: [
      "React",
      "TypeScript",
      "Socket.io",
      "PostgreSQL",
      "Tailwind CSS",
    ],
    screenshots: [
      "https://images.unsplash.com/photo-1503376780353-7e6692767b70?w=800&h=500&fit=crop",
      "https://images.unsplash.com/photo-1517524008697-84bbe3c3fd98?w=800&h=500&fit=crop",
    ],
    status: "completed",
    category: "E-commerce",
    year: 2024,
  },
  {
    id: "project-3",
    title: "Sports4Us",
    description: "A full-stack e-commerce platform for sports gear with cart, checkout, and user reviews.",
    longDescription:
      "Sports4Us is a feature-complete e-commerce experience built with the MERN stack and Stripe for payment processing. I implemented product browsing with filters, a Redux-managed cart, user authentication, and a review system — all within a fully responsive storefront.",
    repositoryUrl: "https://github.com/Shah-K02/Sports4Us",
    githubUrl: "https://github.com/Shah-K02/Sports4Us",
    liveUrl: "https://github.com/Shah-K02/Sports4Us",
    demoUrl: "https://github.com/Shah-K02/Sports4Us",
    image: "https://images.unsplash.com/photo-1461896836934-ffe607ba8211?w=800&h=500&fit=crop",
    technologies: ["React", "Node.js", "MongoDB", "Stripe", "Redux", "Express"],
    screenshots: [
      "https://images.unsplash.com/photo-1517649763962-0c623066013b?w=800&h=500&fit=crop",
    ],
    status: "completed",
    category: "E-commerce",
    year: 2023,
  },
  {
    id: "project-4",
    title: "Task Manager API",
    description: "A RESTful API for organising tasks with role-based access and team collaboration.",
    longDescription:
      "A production-ready Node.js/Express API backed by MongoDB that supports individual and team task management. Features include JWT authentication, admin user management, task CRUD with priority and due-date fields, and paginated queries. All endpoints are documented and tested via Postman.",
    liveUrl: "https://github.com/Shah-K02/Task-Manager-API",
    demoUrl: "https://github.com/Shah-K02/Task-Manager-API",
    repositoryUrl: "https://github.com/Shah-K02/Task-Manager-API",
    githubUrl: "https://github.com/Shah-K02/Task-Manager-API",
    image: "https://images.unsplash.com/photo-1484480974693-6ca0a78fb36b?w=800&h=500&fit=crop",
    technologies: ["Node.js", "Express", "MongoDB", "JWT", "Mongoose"],
    screenshots: [
      "https://images.unsplash.com/photo-1507925921958-8a62f3d1a50d?w=800&h=500&fit=crop",
    ],
    status: "completed",
    category: "API Development",
    year: 2025,
  },
  {
    id: "project-5",
    title: "Portfolio Project",
    description: "This site — a modern, animated developer portfolio built with React and TypeScript.",
    longDescription:
      "A high-performance personal portfolio featuring section-snap scrolling, Three.js particle backgrounds, Framer Motion animations, a dark/light theme system, holographic project cards, an AI chat assistant, and full mobile responsiveness. Built entirely with React 19, TypeScript, and vanilla CSS.",
    liveUrl: "https://shah-kar.netlify.app/",
    demoUrl: "https://shah-kar.netlify.app/",
    repositoryUrl: "https://github.com/Shah-K02/portfolio-project",
    githubUrl: "https://github.com/Shah-K02/portfolio-project",
    image: "https://images.unsplash.com/photo-1467232004584-a241de8bcf5d?w=800&h=500&fit=crop",
    technologies: ["React", "TypeScript", "CSS3", "HTML5", "Framer Motion", "Three.js"],
    screenshots: [
      "https://images.unsplash.com/photo-1504868584819-f8e8b4b6d7e3?w=800&h=500&fit=crop",
    ],
    status: "in-progress",
    category: "Web Development",
    year: 2025,
  },
];